import { gql } from '@apollo/client';
import {
  sharedInvoiceInput,
  sharedInvoiceInputFields,
} from '../../fragments/invoice-input';
import NoteFields from '../../fragments/invoice/note-fields';
import ReferenceFields from '../../fragments/invoice/reference-fields';
import MasterEntityMinimalFields from '../../fragments/master-entity/master-entity-minimal-fields';
import InvoiceDteTypeMinimalFields from '../../fragments/invoice-dte-type/invoice-dte-type-minimal-fields';
import MoneyFields from '../../fragments/money/money-fields';
import OfferMinimalFields from '../../fragments/offer/offer-minimal-fields';
import InvoiceDocumentFinanceStateFields from '../../fragments/invoice/invoice-document-finance-state-fields';

const CLIENT_OFFERS_SUMMARY = gql`
  query clientOffersSummary(${sharedInvoiceInputFields}) {
    invoices(${sharedInvoiceInput}) {
      totalCount
      edges {
        cursor
        node {
          id
          folio
          dateIssued
          creditNoteStatus
          isForOrdering
          dateExpiration
          ...InvoiceDocumentFinanceStateFields
          amountWithIva {
            ...MoneyFields
          }
          dteType {
            ...InvoiceDteTypeMinimalFields
          }
          receiver {
            ...MasterEntityMinimalFields
            invoicesActualPaymentTerm
          }
          offer {
            ...OfferMinimalFields
          }
          references {
            ...ReferenceFields
          }
          creditNotes @client {
            ...NoteFields
          }
          debitNotes @client {
            ...NoteFields
          }
        }
      }
    }
  }
  ${NoteFields}
  ${ReferenceFields}
  ${MasterEntityMinimalFields}
  ${InvoiceDteTypeMinimalFields}
  ${MoneyFields}
  ${OfferMinimalFields}
  ${InvoiceDocumentFinanceStateFields}
`;

export default CLIENT_OFFERS_SUMMARY;
